<template>
  <button @click="toggleMute" :class="['btn', $style.button]">{{buttonLabel}}</button>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import EventBus from '@/lib/event-bus'

  const { mapState } = createNamespacedHelpers('conference')

  export default {
    computed: {
      ...mapState([
        'isCoachMuted'
      ]),
      buttonLabel () {
        return this.isCoachMuted
          ? 'Whisper'
          : 'Stop Whispering'
      }
    },
    methods: {
      toggleMute () {
        EventBus.$emit('TOGGLE_MUTE')
      }
    }
  }
</script>

<style module lang="less" src="./mute-toggle-button.less"></style>



// WEBPACK FOOTER //
// mute-toggle-button.vue?2545a5ff